import type { IAuth } from "./auth";

export default defineNuxtPlugin(() => {
  const redirectToSubscribe = () => {
    const app = useNuxtApp();
    if (!(app.$auth as IAuth).hasActiveSubscription) {
      const router = useRouter();
      return router.replace({ path: "/subscription/select" });
    }
  };

  return {
    provide: {
      redirectToSubscribe,
    },
  };
});
